// 自社サービス FormEdge (https://formedge.app) への外部リンク生成
// コーポレートサイト内の複数箇所から張るため、UTM の付与ルールをここに集約する

export const FORMEDGE_URL = "https://formedge.app";

// FormEdge のサービス紹介ページ（FormEdge 自身で作成・公開しているLP）
export const FORMEDGE_SERVICE_PAGE_URL = "https://value.formedge.app/";

/**
 * 流入元計測用の UTM パラメータを付与したリンクを返す
 * @param url      遷移先URL
 * @param campaign 遷移元ページの識別子 (例: "top", "common")
 * @param content  同一ページ内のどのリンクから遷移したかを区別する識別子 (例: "services-banner", "header")
 */
export function withUtm(url: string, campaign: string, content: string): string {
  const params = new URLSearchParams({
    utm_source: "value-corporate-site",
    utm_medium: "referral",
    utm_campaign: campaign,
    utm_content: content,
  });
  return `${url}?${params.toString()}`;
}

/** UTM 付きの FormEdge 本体 (formedge.app) へのリンク */
export function formedgeLink(campaign: string, content: string): string {
  return withUtm(FORMEDGE_URL, campaign, content);
}

/** UTM 付きの FormEdge サービス紹介ページへのリンク */
export function formedgeServicePageLink(campaign: string, content: string): string {
  return withUtm(FORMEDGE_SERVICE_PAGE_URL, campaign, content);
}
